import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { useAppStore } from '@/stores/app';
import UserInfo from '@/components/UserInfo';
import Aside from './Aside.vue';
export default {
  __name: 'AuthContent',
  setup(__props) {
    const app = useAppStore();
    return (_ctx, _cache) => {
      const _component_el_header = _resolveComponent("el-header");
      const _component_el_aside = _resolveComponent("el-aside");
      const _component_router_view = _resolveComponent("router-view");
      const _component_el_main = _resolveComponent("el-main");
      const _component_el_container = _resolveComponent("el-container");
      return _openBlock(), _createBlock(_component_el_container, {
        class: "app-content-wrapper"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_header, {
          class: "app-content-header"
        }, {
          default: _withCtx(() => [_createVNode(_unref(UserInfo))]),
          _: 1
        }), _createVNode(_component_el_container, {
          class: "app-content-main"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_aside, {
            width: _unref(app).menuWidth
          }, {
            default: _withCtx(() => [_createVNode(Aside)]),
            _: 1
          }, 8, ["width"]), _createVNode(_component_el_main, {
            class: "app-content"
          }, {
            default: _withCtx(() => [_createVNode(_component_router_view)]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      });
    };
  }
};